module.exports = __webpack_public_path__ + "assets/img/lowest_priority.a64de512.svg";